import React from "react";
import NavbarDesktop from "./NavBarDesktop";
import NavbarMobile from "./NavbarMobile";

const NavBar = ({ mode }) => {
  return (
    <div>
      <NavbarDesktop mode={mode} />
      <NavbarMobile mode={mode} />
    </div>
  );
};

export default NavBar;
